import dynamic from 'next/dynamic'
import { FC } from 'react'

import { useModalState } from '../../context/ModalStateContext'
import Modal from '../modal/Modal'
import { useSafeTranslation } from 'hooks/useSafeTranslation'
import Illustration from 'atomic/components/atoms/illustrations/Illustration'
import { Box, Button, Container, Heading, Text } from 'atomic'
import { Link } from 'components/link/Link'
import { container } from './GetAppModal.css'
import { useRouter } from 'next/router'

import * as gtag from 'lib/gtag'

const AppBadges = dynamic(() => import('../appbadges/AppBadges'), { ssr: false })

const GetAppModal: FC = () => {
  const { showGetAppModal, setShowGetAppModal } = useModalState()
  const { t } = useSafeTranslation()
  const router = useRouter()

  return (
    <Modal className={container} show={showGetAppModal} onClosed={() => setShowGetAppModal(false)}>
      <Container display={'flex'} flexDirection={'column'} gap={'l'} alignItems={'center'} justifyContent={'center'}>
        <Illustration name={'hand-4'} height={120} />
        <Box display={'flex'} flexDirection="column" gap="s" alignItems={'center'} justifyContent={'center'}>
          <Heading as="h2" fontSize="xl" marginBottom={'none'}>
            {t('get_app_modal_title')}
          </Heading>
          <Text fontSize={'base'} marginBottom={'none'}>
            {t('get_app_modal_text')}
          </Text>
        </Box>
        <Link href={`https://app.onceupon.photo/authentication/signin/?lang=${router.locale}`} target="_blank" rel="noreferrer">
          <Button
            variant={'cta'}
            size={'l'}
            aria-label="webapp-button"
            onClick={() => {
              gtag.logEvent('click_webapp_button', { source: 'gettheappmodal' })
            }}
          >
            {t('create_in_webapp_cta')}
          </Button>
        </Link>
      </Container>
      <AppBadges />
    </Modal>
  )
}

export default GetAppModal
